
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { Cookies } from 'react-cookie';
import { useEffect, useState } from 'react';
import { BindReportGrid, ReverseFormatDate, exportToExcel, formatDate, setFocus, setTitle, OpenBase64Pdf } from "../Common/Common";
import { API_SERVER } from '../../EnvConfig/env_config';
import { post } from '../Common/service';
import { AlertBox, AutoCompleteBox } from '../Common/Input';
import { getCommonData } from '../Common/CommanServices';
import { useNavigate } from "react-router-dom";
import Loader from '../Layout/Loader';

const SMSReport = ({ open, setOpen }) => {
    const navigate = useNavigate();
    const cookies = new Cookies();
    const Token = cookies.get('token')
    const LoginUserCode = cookies.get('loginUserCode');
    const SalesPersonCode = cookies.get('salesPersonCode')
    const [isUpdate, setIsUpdate] = useState(false)
    const [salesPerson, setSalesPerson] = useState([]);
    const [MenuText, setMenuText] = useState("Request Report");
    const [isLoading, setIsLoading] = useState(false);
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [tableData, setTableData] = useState({})
    const [FilterData, setFilterData] = useState({
        PageIndex: "1",
        DateFrom: "",
        DateTo: "",
    });
    const HandleChange = (prop, value) => {
        setFilterData(FilterData => ({ ...FilterData, [prop]: value }));
    }
    useEffect(() => {
        setTitle('SMSReport', setOpen);
        setTimeout(() => {
            setMenuText(document.title);
        }, 500)
    }, [])

    //useEffect(() => {
    //    GetDate();
    //}, [FilterData.PageIndex, isUpdate]);

    const GetDate = (Type = 'S', PI = FilterData?.PageIndex || "1") => {
        const loginCodeString = String(LoginUserCode);
        const data = {
            ...FilterData, Type: Type, Token, LoginUserCode: loginCodeString, PageIndex: `${PI}`
        }
        setIsLoading(true)
        post(`${API_SERVER}/api/Report/ShowExSMSReport`, { ...data }, (res) => {
            if (res.Status === 'SUCCESS') {
                if (Type === 'S') {
                    setTableData({
                        ...res
                    });
                }
                else {
                    if (Array.isArray(res.Data)) {
                        exportToExcel(res.Data, 'SMSReport');

                    }
                }
            }
            else if (res.Status === "EXPIRED") {
                navigate('/Login')
            }
            else if (res.Message !== "") {
                AlertBox(res.Status, res.Message, res.Focus);
                setTableData(
                    {
                        totalRecord: 0,
                        gridData: [{
                        }]
                    })
            }
            setIsLoading(false)
        })
    }

    const handleChange1 = (event, value) => {
        GetDate("S", value);
    };
    const handleClearData = () => {
        setFilterData(
            {
                PageIndex: "1",
                DateFrom: "",
                DateTo: "",
            }
        );
        setTableData(
            {
                totalRecord: 0,
                gridData: [{
                }]
            })
        setIsUpdate(!isUpdate)
        setFocus('txtDateFrom');
    }

    const searchHandle = async () => {
        setFilterData({
            ...FilterData,
            PageIndex: "1",
        })
        GetDate();
    }
    let SalesPersonArr = []
    for (let i = 0; i < salesPerson.length; i++) {
        let mydata = salesPerson[i]?.values
        SalesPersonArr.push(mydata)
    };
    const handleDownloadExcel = async () => {
        GetDate('E');
    }
    useEffect(() => {
        if (FilterData.DateFrom) {
            const fromDateObj = new Date(FilterData.DateFrom);
            const toDateObj = new Date(FilterData.DateTo);

            if (
                !FilterData.DateTo ||
                toDateObj <= fromDateObj
            ) {
                const nextDay = new Date(fromDateObj);
                nextDay.setDate(fromDateObj.getDate() + 1);

                const formattedNextDay = formatDate(nextDay);

                setFilterData(prev => ({
                    ...prev,
                    DateTo: formattedNextDay
                }));
            }
        }
    }, [FilterData.DateFrom]);


    return (
        <main id="main" className="main" style={open ? {} : { marginLeft: "0" }}>
            <section className="section dashboard">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="content-box">
                            <div className="heading-box">
                                <div className="heading">
                                    <h6 className="m-0 font-weight-bold text-primary">{MenuText}</h6>
                                </div>
                            </div>
                            <div className="form-box service-content-area">
                                <div className="row align-items-end">
                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">From Date</label>
                                            <DatePicker
                                                selected={ReverseFormatDate(FilterData.DateFrom) || null}
                                                id='txtDateFrom'
                                                className="form-control"
                                                placeholderText='From Date'
                                                dateFormat={'dd-MMM-yyyy'}
                                                autoComplete='off'
                                                onChange={(date) => {
                                                    setFilterData({ ...FilterData, DateFrom: formatDate(date) })
                                                }}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        setFocus('txtDateTo')
                                                    };
                                                }}
                                                maxDate={new Date()}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">To Date</label>
                                            <DatePicker
                                                selected={ReverseFormatDate(FilterData.DateTo) || null}
                                                id='txtDateTo'
                                                className="form-control"
                                                placeholderText='To Date'
                                                dateFormat={'dd-MMM-yyyy'}
                                                autoComplete='off'
                                                onChange={(date) => {
                                                    setFilterData({ ...FilterData, DateTo: formatDate(date) })
                                                }}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        setFocus('btnSearch')
                                                    };
                                                }}
                                                minDate={new Date(FilterData.DateFrom) || null}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-12 mt-1">
                                        <div className="lms-new-button text-center">
                                            <button className="button save-btn" id='btnSearch' onClick={searchHandle}>
                                                <i className="bi bi-search" /> Search
                                            </button>
                                            <button className="button export-btn" onClick={handleDownloadExcel}>
                                                <i className="bi bi-download" /> Export
                                            </button>
                                            <button className="button reset-btn" onClick={handleClearData} >
                                                <i className="bi bi-arrow-clockwise" /> Reset
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <BindReportGrid tableData={tableData} setFilterData={setFilterData} filterData={FilterData} currentPageNo={currentPageNo} handleChange1={handleChange1} />
            {isLoading ? <Loader text='Please wait' size='100px' img_path='./assets/img/giphy.gif' /> : <></>}
        </main>
    )
}
export default SMSReport